import courseService from "@/services/api/course/course"
import courseCalendarService from "@/services/api/course/calendar"
import courseClassService from "@/services/api/course/class"
import enrollmentService from "@/services/api/course/enrollment"
import creditsService from "@/services/api/course/credits"

export default {
  namespaced: true,
  modules: {
    course: courseService,
    calendar: courseCalendarService,
    class: courseClassService,
    enrollment: enrollmentService,
    credits: creditsService
  }
}
